import { IEnvironmentConfig } from "@env/environment.model";

export function readJSONEnvionmentConfigData(environement: string): IEnvironmentConfig {
  const request = new XMLHttpRequest();
  request.open('GET', `/assets/environments/${environement}.env-config.json`, false);
  request.send();
  const env = JSON.parse(request.responseText);
  return env as IEnvironmentConfig;
}

